import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, useNavigate } from "react-router-dom";
import { connect } from 'react-redux'
import { useTranslation } from 'react-i18next';
import i18n from "./i18n"
import { load as loadProducts } from "./actions/product";
import { getLink, getFormats } from "./dataProvider/links.js"
import ScrollToTop from "./components/ScrollToTop";
import Home from "./components/Home"
import Header from "./components/Header"
import Footer from "./components/Footer"
// import Favicon from "./components/Favicon"
import Payment from "./components/payment/Payment"
import PaymentConfirmation from "./components/payment/Confirm"
import PaymentSecure from "./components/payment/Secure"
import Pricing from "./components/Pricing"
import Contact from "./components/Contact"
import FAQ from "./components/FAQ"
import Unsubscribe from "./components/user/Unsubscribe"
import Login from "./components/user/Login"
import Terminate from "./components/user/Terminate"
import LoginRedirect from "./components/user/LoginRedirect"
import ForgotPassword from "./components/user/ForgotPassword"
import PasswordSent from "./components/user/PasswordSent"
import Account from "./components/user/Account"
import PasswordChange from "./components/user/PasswordChange"
import ManageAccount from "./components/user/ManageAccount"
import Cloud from "./components/user/Cloud"
import Invoice from "./components/user/Invoice"
import Convert from "./components/user/Convert"
import Legal from "./components/legal/Legal"
import Data from "./components/legal/Data"
import Warranty from "./components/legal/Warranty"
import GSC from "./components/legal/GSC"
import Subscription from "./components/legal/Subscription"
import Cookie from "./components/legal/Cookie"
import UnsubscribeEmail from "./components/UnsubscribeEmail.jsx"
import { CookiesProvider } from 'react-cookie';
import Opinion from "./components/Opinion";
import UploadProcess from "./components/upload/UploadProcess.jsx";

const langs = ["en", "fr", "es"]

function Redirect() {

  let navigate = useNavigate();
  const { i18n } = useTranslation();

  useEffect(() => {
    if (i18n.language) return navigate(getLink("home", i18n.language));
  })

  return null;
}

function App(props) {

  const [language, setLanguage] = useState(null);

  useEffect(() => {
    const handleLangChange = () => {
      if (language === i18n.language) return;
      setLanguage(i18n.language);
      props.dispatch(loadProducts(i18n.language))
    }

    i18n.on('languageChanged', handleLangChange)
    return () => {
      i18n.off('languageChanged', handleLangChange)
    };
  });

  return (
    <CookiesProvider>
      <Router>
        <ScrollToTop>
          <UploadProcess />
            <div className="content-container">
              <div className="inner-body">
                <Header />
                {/* <Favicon /> */}
                <Routes>
                  {langs.map(lang => <Route path={getLink("home", lang)} exact key={"home" + lang} element={<Home lang={lang} />} />)}
                  {langs.map(lang => <Route path={getLink("payment1", lang)} exact key={"paymentv1" + lang} element={<Payment lang={lang} />} />)}
                  {langs.map(lang => <Route path={getLink("pricing", lang)} exact key={"pricing" + lang} element={<Pricing lang={lang} />} />)}
                  {langs.map(lang => <Route path={getLink("contact", lang)} exact key={"contact" + lang} element={<Contact lang={lang} />} />)}
                  {langs.map(lang => <Route path={getLink("faq", lang)} exact key={"faq" + lang} element={<FAQ lang={lang} />} />)}
                  {langs.map(lang => <Route path={getLink("paymentConfirmation", lang)} exact key={"paymentConfirmation" + lang} element={<PaymentConfirmation lang={lang} />} />)}
                  {langs.map(lang => <Route path={getLink("paymentSecure", lang)} exact key={"paymentSecure" + lang} element={<PaymentSecure lang={lang} />} />)}
                  {langs.map(lang => <Route path={getLink("unsubscribe", lang)} exact key={"unsubscribe" + lang} element={<Unsubscribe lang={lang} />} />)}
                  {langs.map(lang => <Route path={getLink("login", lang)} exact key={"login" + lang} element={<Login lang={lang} />} />)}
                  {langs.map(lang => <Route path={getLink("forgotPassword", lang)} exact key={"forgotPassword" + lang} element={<ForgotPassword lang={lang} />} />)}
                  {langs.map(lang => <Route path={getLink("passwordSent", lang)} exact key={"passwordSent" + lang} element={<PasswordSent lang={lang} />} />)}
                  {langs.map(lang => <Route path={getLink("passwordChange", lang)} exact key={"passwordChange" + lang} element={<PasswordChange lang={lang} />} />)}
                  {langs.map(lang => <Route path={getLink("account", lang)} exact key={"account" + lang} element={<Account lang={lang} />} />)}
                  {langs.map(lang => <Route path={getLink("manageAccount", lang)} exact key={"manageAccount" + lang} element={<ManageAccount lang={lang} />} />)}
                  {langs.map(lang => <Route path={getLink("cloud", lang)} exact key={"cloud" + lang} element={<Cloud lang={lang} />} />)}
                  {langs.map(lang => <Route path={getLink("invoice", lang)} exact key={"invoice" + lang} element={<Invoice lang={lang} />} />)}
                  {langs.map(lang => <Route path={getLink("convert", lang)} exact key={"cloud" + lang} element={<Convert lang={lang} />} />)}
                  {langs.map(lang => <Route path={getLink("legal", lang)} exact key={"legal" + lang} element={<Legal lang={lang} />} />)}
                  {langs.map(lang => <Route path={getLink("data", lang)} exact key={"data" + lang} element={<Data lang={lang} />} />)}
                  {langs.map(lang => <Route path={getLink("warranty", lang)} exact key={"warranty" + lang} element={<Warranty lang={lang} />} />)}
                  {langs.map(lang => <Route path={getLink("gsc", lang)} exact key={"gsc" + lang} element={<GSC lang={lang} />} />)}
                  {langs.map(lang => <Route path={getLink("subscription", lang)} exact key={"subscription" + lang} element={<Subscription lang={lang} />} />)}
                  {langs.map(lang => <Route path={getLink("cookie", lang)} exact key={"cookie" + lang} element={<Cookie lang={lang} />} />)}
                  {langs.map(lang => <Route path={getLink("terminate", lang)} exact key={"terminate" + lang} element={<Terminate lang={lang} />} />)}
                  {langs.map(lang => <Route path={getLink("splitPdf", lang)} exact key={"splitPdf" + lang} element={<Home format={`splitPdf`} split={true} lang={lang} />} />)}
                  {langs.map(lang => <Route path={getLink("opinion", lang)} exact key={"opinion" + lang} element={<Opinion lang={lang} />} />)}
                  <Route path="/unsubscribe-email/:email" exact component={UnsubscribeEmail} />
                  {
                    getFormats().map(format => langs.map(lang => <Route path={getLink(`convert${format}`, lang)} exact key={"convert" + format + lang} element={<Home format={format} lang={lang} />} />))
                  }
                  {
                    (["image", "PDF", ""]).map(format => langs.map(lang => <Route path={getLink(`compress${format}`, lang)} exact key={"compress" + format + lang} element={<Home format={`compress${format}`} compress={true} lang={lang} />} />))
                  }
                  <Route path="/login/redirect" exact element={<LoginRedirect />} />
                  <Route path="/*" element={<Redirect />} />
                </Routes>
                <Footer />
              </div>
            </div>
        </ScrollToTop>
      </Router>
    </CookiesProvider>
  );
}

const mapDispatchToProps = dispatch => ({ dispatch })

export default connect(null, mapDispatchToProps)(App);